import React from 'react';

import SearchInput from 'pages/Landings/components/SearchInput';
import Templates from 'pages/Landings/components/Templates';

import useStyles from './styles';

interface Props {
    className?: string;
}

const TitleSection: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();

    return (
        <section className={cx(classes.root, className)}>
            <SearchInput className={classes.input} />
            <Templates />
        </section>
    );
};

export default TitleSection;
